module.exports = __webpack_public_path__ + "img/model_34_zh.8cec869e.jpg";